import { render, staticRenderFns } from "./MesaNewComandasOpeneds.vue?vue&type=template&id=22bb8cfe&scoped=true"
import script from "./MesaNewComandasOpeneds.vue?vue&type=script&lang=js"
export * from "./MesaNewComandasOpeneds.vue?vue&type=script&lang=js"
import style0 from "./MesaNewComandasOpeneds.vue?vue&type=style&index=0&id=22bb8cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb8cfe",
  null
  
)

export default component.exports